import { createContext } from 'utils/react-helpers';

const [NegotiationsProvider, useNegotiations] = createContext({
  name: 'NegotiationsContext',
});

export { NegotiationsProvider, useNegotiations };
